import api from "@/api/axios/axios.js";

export async function getMe() {
    const resp = await api.get("/login/me/");
    return resp.data;
}

export async function updateMe(payload) {
    const resp = await api.put("/login/me/", payload);
    return resp.data;
}

export async function changeMyPassword(payload) {
    const resp = await api.put("/login/me/password/", payload);
    return resp.data;
}

export async function uploadMyPhoto(file) {
    const fd = new FormData();
    fd.append("photo", file);

    const resp = await api.post("/login/me/photo/", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data;
}

export async function removeMyPhoto() {
    const fd = new FormData();
    fd.append("remove", "1");

    const resp = await api.post("/login/me/photo/", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data;
}